import React from 'react';

const Bank = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_30908_16753)">
      <rect x="4" y="3" width="32" height="32" rx="16" fill="white" />
      <rect
        x="6"
        y="5"
        width="28"
        height="28"
        rx="14"
        fill="var(--color-primary)"
      />
      <path
        opacity="0.2"
        d="M27.3125 16.75H12.6875L20 12.25L27.3125 16.75Z"
        fill="white"
      />
      <path
        d="M12.6875 17.3126H14.375V21.8126H13.25C13.1008 21.8126 12.9577 21.8719 12.8523 21.9774C12.7468 22.0829 12.6875 22.226 12.6875 22.3751C12.6875 22.5243 12.7468 22.6674 12.8523 22.7729C12.9577 22.8784 13.1008 22.9376 13.25 22.9376H26.75C26.8992 22.9376 27.0423 22.8784 27.1477 22.7729C27.2532 22.6674 27.3125 22.5243 27.3125 22.3751C27.3125 22.226 27.2532 22.0829 27.1477 21.9774C27.0423 21.8719 26.8992 21.8126 26.75 21.8126H25.625V17.3126H27.3125C27.4349 17.3125 27.5539 17.2725 27.6515 17.1986C27.7491 17.1247 27.8199 17.021 27.8532 16.9033C27.8865 16.7855 27.8805 16.6601 27.8361 16.546C27.7917 16.432 27.7113 16.3355 27.6071 16.2713L20.2946 11.7713C20.206 11.7168 20.104 11.688 20 11.688C19.896 11.688 19.794 11.7168 19.7054 11.7713L12.3929 16.2713C12.2887 16.3355 12.2083 16.432 12.1639 16.546C12.1195 16.6601 12.1135 16.7855 12.1468 16.9033C12.1801 17.021 12.2509 17.1247 12.3485 17.1986C12.4461 17.2725 12.5651 17.3125 12.6875 17.3126ZM15.5 17.3126H17.75V21.8126H15.5V17.3126ZM21.125 17.3126V21.8126H18.875V17.3126H21.125ZM24.5 21.8126H22.25V17.3126H24.5V21.8126ZM20 12.9104L25.3255 16.1876H14.6745L20 12.9104ZM28.4375 24.6251C28.4375 24.7743 28.3782 24.9174 28.2727 25.0229C28.1673 25.1284 28.0242 25.1876 27.875 25.1876H12.125C11.9758 25.1876 11.8327 25.1284 11.7273 25.0229C11.6218 24.9174 11.5625 24.7743 11.5625 24.6251C11.5625 24.476 11.6218 24.3329 11.7273 24.2274C11.8327 24.1219 11.9758 24.0626 12.125 24.0626H27.875C28.0242 24.0626 28.1673 24.1219 28.2727 24.2274C28.3782 24.3329 28.4375 24.476 28.4375 24.6251Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_30908_16753"
        x="0"
        y="0"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_30908_16753"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30908_16753"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30908_16753"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export {Bank};
